export interface Quote {
  quoteId: string;
  status: string;
  description?: string;
  reason?: string;
  hotelName: string;
  leadName: string;
  checkInDate: string; // as DateTime
  checkOutDate: string; // as DateTime
  totalPrice: number;
  currencyCode: string;
  bookerUsername: string;
  createdOnUtc: string; // as DateTime
  approvers?: string[]
}

export enum RequestDateSearchType {
  BOOKING = 'Booking',
  CHECKIN = 'CheckIn',
  CHECKOUT = 'CheckOut',
}

export enum RequestStatus {
  APPROVED = 'Approved',
  CANCELLED = 'Cancelled',
  DECLINED = 'Declined',
  PENDINGAPPROVAL = 'PendingApproval',
}

export enum SortDirection {
  ASCENDING = 'Ascending',
  DESCENDING = 'Descending'
}

export const OwnerTypeValues = {
  approve: 'Approve',
  request: 'Request'
} as const

type ObjecValues<T> = T[keyof T];
type OwnerType = ObjecValues<typeof OwnerTypeValues>


export interface GetAllApprovalRequestsRequest {
  DateSearchType: RequestDateSearchType;
  StartDate: string;
  EndDate: string;
  PageSize: number;
  PageNumber: number;
  SortBy: string;
  SortDirection: SortDirection;
  Status: RequestStatus[];
  HotelName: string;
  QuoteId: string;
  LeadName: string;
  OwnerType: OwnerType;
  BookerUsernames: string[];
  Approver: string;
}

export interface GetAllApprovalRequestsResponse {
  data: Quote[];
  pageNumber: number;
  pageSize: number;
  total: number;
}

export interface GetApprovalRequestRequest {
  quoteId: string;
}

export interface GetApprovalRequestResponse {
  id: string; // Quote Id
  role: 'Booker' | 'Approver'; // Role of logged-in user in this quote
  isExpired: boolean; // If quote is expired
  status: string; // Quote status
  totalPrice: number; // Total price
  currencyCode: string // Currency code of total price
  createdOnUtc: string; // Date and time when quote created
  reservationIdWithPrefix: string; // ID of completed reservation in format: RX0000000
  reservationGuid: string; // Guid of completed reservation
  termsAndConditions: string; // Terms and conditions
  // hotel: Hotel; // Hotel data
  // data: ReservationData; // Cached data which was passed to CreateReservation endpoint
  // roomRates: RoomRates[]; // Details about selected room rates
}

export interface RequestBookingPresetModel extends GetAllApprovalRequestsRequest {
  Name: string;
  Classname: string;
}

export const RequestbookingsSortFields = {
  quoteId: "QuoteId",
  hotelName: "HotelName",
  leadName: "LeadName",
  checkInDate: "CheckInDate",
  checkOutDate: "CheckOutDate",
  amount: "Amount",
  status: "Status",
  username: "Username",
  createdOn: "CreatedOn",
  approvers: "Approvers",
} as const

export const RequestBookingSortFieldsMap = {
  "id": RequestbookingsSortFields.quoteId,
  "hotelName": RequestbookingsSortFields.hotelName,
  "leadName": RequestbookingsSortFields.leadName,
  "checkInDate": RequestbookingsSortFields.checkInDate,
  "checkOutDate": RequestbookingsSortFields.checkOutDate,
  "totalPrice": RequestbookingsSortFields.amount,
  "status": RequestbookingsSortFields.status,
  "bookerUsername": RequestbookingsSortFields.username,
  "createdOnUtc": RequestbookingsSortFields.createdOn,
  "approvers": RequestbookingsSortFields.approvers,
} as const

export const ReverseRequestBookingSortFieldsMap = {
  [RequestbookingsSortFields.quoteId]: "id",
  [RequestbookingsSortFields.hotelName]: "hotelName",
  [RequestbookingsSortFields.leadName]: "leadName",
  [RequestbookingsSortFields.checkInDate]: "checkInDate",
  [RequestbookingsSortFields.checkOutDate]: "checkOutDate",
  [RequestbookingsSortFields.amount]: "totalPrice",
  [RequestbookingsSortFields.status]: "status",
  [RequestbookingsSortFields.username]: "bookerUsername",
  [RequestbookingsSortFields.createdOn]: "createdOnUtc",
  [RequestbookingsSortFields.approvers]: "approvers",
} as const